module.exports = __webpack_public_path__ + "media/br-ding.8d91b08f.mp3";